// import { BrowserModule } from '@angular/platform-browser';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { NgModule } from '@angular/core';
// import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// import { CoreModule } from './@core/core.module';
// import { ThemeModule } from './@theme/theme.module';
// import { AppComponent } from './app.component';
// import { AppRoutingModule } from './app-routing.module';
// import {
//   NbDatepickerModule,
//   NbDialogModule,
//   NbAlertModule,
//   NbMenuModule,
//   NbSidebarModule,
//   NbToastrModule,
//   NbWindowModule,
//   NbTabsetModule,
//   NbRadioModule,
//   NbAccordionModule,
//   NbAutocompleteModule,
//   NbToggleModule
// } from '@nebular/theme';
// import { GraphQLModule } from './graphql.module';
// import { NbSelectModule, NbOptionModule } from '@nebular/theme';
// import { CommonModule } from '@angular/common';
// import { ComponentsModule } from './components/components.module';
// import { CredentialsInterceptor } from './_helpers/credentials.interceptor';
// import { CustomPipesModule } from './_pipes/pipe.module';
// import { AuthService } from './_services/auth.service';
// import { LoggerService } from './_services/logger.service';
// import { NotifierService } from './_services/notifier.service';
// import { UtilsService } from './_services/utils.service';
// import { ErrorInterceptor } from './_helpers/error.interceptor';
// import { DateTimeService } from './_services/datetime.service';
// import { NgxEchartsModule } from 'ngx-echarts';
// import { GoogleMapsModule } from '@angular/google-maps';
// import { MatAutocompleteModule } from '@angular/material/autocomplete';
// import { MatInputModule } from '@angular/material/input'; // Ensure you also import MatInputModule if you're using input within mat-autocomplete
// import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { NgSelectModule } from '@ng-select/ng-select'; // Import NgSelectModule
// import { LOCALE_ID } from '@angular/core';
// import { registerLocaleData } from '@angular/common';
// import localeIt from '@angular/common/locales/it';


// registerLocaleData(localeIt, 'it');


// @NgModule({
//   declarations: [AppComponent],
//   imports: [
//     BrowserModule,
//     GraphQLModule,
//     NgSelectModule,
//     BrowserAnimationsModule,
//     NbToggleModule,
//     HttpClientModule,
//     NbOptionModule,
//     GoogleMapsModule,
//     NgxEchartsModule,
//     NbAccordionModule,
//     NbSelectModule,
//     NbRadioModule,
//     NbAutocompleteModule,
//     NbTabsetModule,
//     AppRoutingModule,
//     NbDatepickerModule.forRoot(),
//     NbSidebarModule.forRoot(),
//     NbMenuModule.forRoot(),
//     // NbDateFnsDateModule,
//     NbDialogModule.forRoot(),
//     NbWindowModule.forRoot(),
//     NbToastrModule.forRoot(),
//     CoreModule.forRoot(),
//     ThemeModule.forRoot(),
//     NbDialogModule.forRoot({
//       hasBackdrop: true,
//       closeOnEsc: true,
//       autoFocus: false,
//       closeOnBackdropClick: false,
//       hasScroll: true,
//     }),
//     GraphQLModule,
//     ComponentsModule,
//     CustomPipesModule,
//     CommonModule,
//     MatAutocompleteModule,
//     MatInputModule, // Import MatInputModule if you're using input within mat-autocomplete
//     FormsModule,
//     ReactiveFormsModule
//   ],
//   providers: [
//     LoggerService, // Servizio per loggare i messaggi in console
//     NotifierService, // Servizio di notifiche a schermo Toastr
//     UtilsService, // Funzioni di utility
//     DateTimeService, // Funzioni di utility per date time,
//     { provide: LOCALE_ID, useValue: 'it' },
//     AuthService, // Funzioni di autenticazione
//     {
//       provide: HTTP_INTERCEPTORS,
//       useClass: CredentialsInterceptor,
//       multi: true,
//     },
//     {
//       provide: HTTP_INTERCEPTORS,
//       useClass: ErrorInterceptor,
//       multi: true,
//     }
//   ],
//   bootstrap: [AppComponent],
// })
// export class AppModule {
// }























import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { GraphQLModule } from './graphql.module';
import { ComponentsModule } from './components/components.module';
import { CustomPipesModule } from './_pipes/pipe.module';

import { CredentialsInterceptor } from './_helpers/credentials.interceptor';
import { ErrorInterceptor } from './_helpers/error.interceptor';
import { RefreshInterceptor } from './_helpers/refresh.interceptor';
import { AuthService } from './_services/auth.service';
import { LoggerService } from './_services/logger.service';
import { NotifierService } from './_services/notifier.service';
import { UtilsService } from './_services/utils.service';
import { DateTimeService } from './_services/datetime.service';

import { NbDatepickerModule, NbDialogModule, NbAlertModule, NbMenuModule, NbSidebarModule, NbToastrModule, NbWindowModule, NbTabsetModule, NbRadioModule, NbAccordionModule, NbAutocompleteModule, NbToggleModule, NbSelectModule, NbOptionModule } from '@nebular/theme';

import { NgxEchartsModule } from 'ngx-echarts';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import {  registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { AuthModule } from './pages/auth/auth.module';

registerLocaleData(localeIt, 'it');

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AuthModule,
    FormsModule,
    ReactiveFormsModule,

    // Angular Material / Form UI
    MatAutocompleteModule,
    MatInputModule,
    NgSelectModule,

    NbToggleModule,
    NbOptionModule,
    NbAccordionModule,
    NbSelectModule,
    NbRadioModule,
    NbAutocompleteModule,
    NbTabsetModule,
    NbDatepickerModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbDialogModule.forRoot({
      hasBackdrop: true,
      closeOnEsc: true,
      autoFocus: false,
      closeOnBackdropClick: false,
      hasScroll: true,
    }),

    // External libs
    NgxEchartsModule,
    GoogleMapsModule,

    // App Modules
    GraphQLModule,
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    ComponentsModule,
    CustomPipesModule,
    AppRoutingModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'it' },
    AuthService,
    LoggerService,
    NotifierService,
    UtilsService,
    DateTimeService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CredentialsInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    // After ErrorInterceptor so it sees a 401 first and can refresh + retry before any logout.
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
